import React, { useState } from "react";

const SplitLinkModal = ({ onSubmit, onClose, loading, error }) => {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    seats: "",
    invitation_name: "",
    allow_splitting: false,
    one_time_use: false,
    auto_approve: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, seats: parseInt(form.seats, 10) });
  };

  return (
    <div className="inviteflow-modal-overlay">
      <div className="inviteflow-modal">
        <h3 className="inviteflow-modal__title">Create Sub-Link</h3>
        {error && <p className="inviteflow-modal__error">{error}</p>}
        <form onSubmit={handleSubmit} className="inviteflow-modal__form">
          <div className="inviteflow-modal__row">
            <label>
              First Name
              <input
                type="text"
                name="first_name"
                value={form.first_name}
                onChange={handleChange}
                required
                placeholder="John"
              />
            </label>
            <label>
              Last Name
              <input
                type="text"
                name="last_name"
                value={form.last_name}
                onChange={handleChange}
                required
                placeholder="Smith"
              />
            </label>
          </div>
          <label>
            Manager Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="manager@example.com"
            />
          </label>
          <label>
            Phone (optional)
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+201001234567"
            />
          </label>
          <label>
            Seats to Allocate
            <input
              type="number"
              name="seats"
              value={form.seats}
              onChange={handleChange}
              required
              min="1"
              placeholder="e.g. 20"
            />
          </label>
          <label>
            Link Name (optional)
            <input
              type="text"
              name="invitation_name"
              value={form.invitation_name}
              onChange={handleChange}
              placeholder="e.g. HR — Cairo Office"
            />
          </label>
          <div className="inviteflow-modal__checkboxes">
            <label className="inviteflow-modal__checkbox">
              <input
                type="checkbox"
                name="allow_splitting"
                checked={form.allow_splitting}
                onChange={handleChange}
              />
              Allow further splitting
            </label>
            <label className="inviteflow-modal__checkbox">
              <input
                type="checkbox"
                name="one_time_use"
                checked={form.one_time_use}
                onChange={handleChange}
              />
              One-time use
            </label>
            <label className="inviteflow-modal__checkbox">
              <input
                type="checkbox"
                name="auto_approve"
                checked={form.auto_approve}
                onChange={handleChange}
              />
              Auto-approve registrations
            </label>
          </div>
          <div className="inviteflow-modal__footer">
            <button
              type="button"
              className="inviteflow-btn inviteflow-btn--secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inviteflow-btn inviteflow-btn--primary"
              disabled={loading}
            >
              {loading ? "Creating…" : "Create Sub-Link"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SplitLinkModal;
